import React from 'react';
import { UserComponentConfig } from '@craftjs/core';
import { merge } from 'lodash';

type Options = {
	componentName?: string;
};

export const customizeCraftJsComponent = <P extends {}>(
	BaseComponent: React.ComponentType<P> & {
		craft: Partial<UserComponentConfig<P>>;
	},
	craftJsSettings: Partial<UserComponentConfig<P>>,
	options?: Options
) => {
	const NewComponent: React.FC<P> & { craft: UserComponentConfig<P> } = (
		props
	) => <BaseComponent {...props} />;

	NewComponent.craft = merge(
		{},
		BaseComponent.craft,
		craftJsSettings
	) as UserComponentConfig<P>;

	Object.defineProperty(NewComponent, 'name', {
		value: options?.componentName || BaseComponent.name
	});

	return NewComponent;
};
